<template>
    <div class="saveOrUpdateCrud">
        <div>
            <el-page-header @back="close" content="准考证贴详情"></el-page-header>
        </div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="低分辨率" name="first">
                <div style="width: 100%;float: right;text-align: right;margin-right: 20px;">
                    <el-button size="mini" plain type="primary" v-display:sysExamRoom-img @click="downloadResult('pages')" >导出图片座位帖</el-button>
                    <el-button size="mini" plain type="primary" v-display:sysExamRoom-pdf @click="printOutpdf('pages')">导出PDF座位帖</el-button>
                    <el-button type="text" v-print="`#pages`">在线打印</el-button>
                </div>
                <div style="width: 100%;height: 100%;margin-top: 30px;" id="pages" >
                    <div v-for="(item,index) in examRoomStudentList" style="height: 1620px;margin-top: 20px">
                        <div v-for="ticketForm in item" style="height: 280px;width: 46%;float: left;margin-right: 20px;margin-top: 40px;margin-left: 20px">
                            <table border="1" style="color:#000;font-size: 14px;text-align: center;height:280px;width: 100%" cellspacing="0" cellpadding="0"  align="center">
                                <tr style="height: 50px">
                                    <th style="width: 90px">考生姓名</th>
                                    <td style="width: 90px">{{ticketForm.name}}</td>
                                    <th>性别</th>
                                    <td style="width: 80px">{{ticketForm.sex}}</td>
                                    <th>身份证号</th>
                                    <td>{{ticketForm.idCard}}</td>
                                </tr>
                                <tr style="height: 50px">
                                    <th>报考专业</th>
                                    <td colspan="3">{{ticketForm.examMajor}}</td>
                                    <th>准考证号</th>
                                    <td>{{ticketForm.ticketNumber}}</td>
                                </tr>
                                <tr style="height: 50px">
                                    <th>考试科目</th>
                                    <th>考试时间</th>
                                    <th>教室号</th>
                                    <th>考场号</th>
                                    <th>座位号</th>
                                    <th rowspan="3"><img style="width: 110px; height: 130px;margin-top: 10px" id="faceImg" :src="ticketForm.faceImg"/></th>
                                </tr>

                                <tr style="height: 50px" v-if="ticketForm.majorItemList && ticketForm.majorItemList[0]">
                                    <td>{{ticketForm.majorItemList[0].name}}</td>
                                    <td>{{ticketForm.majorItemList[0].examStartTime.substring(0,5)}}--{{ticketForm.majorItemList[0].examEndTime.substring(0,5)}}</td>
                                    <td>{{ticketForm.majorItemList[0].classroomNum}}</td>
                                    <td>{{ticketForm.majorItemList[0].examRoomNum}}</td>
                                    <td>{{ticketForm.majorItemList[0].seatNumber}}</td>
                                </tr>

                                <tr style="height: 50px" v-if="ticketForm.majorItemList && ticketForm.majorItemList[1]">
                                    <td>{{ticketForm.majorItemList[1].name}}</td>
                                    <td>{{ticketForm.majorItemList[1].examStartTime.substring(0,5)}}--{{ticketForm.majorItemList[1].examEndTime.substring(0,5)}}</td>
                                    <td>{{ticketForm.majorItemList[1].classroomNum}}</td>
                                    <td>{{ticketForm.majorItemList[1].examRoomNum}}</td>
                                    <td>{{ticketForm.majorItemList[1].seatNumber}}</td>
                                </tr>
                                <tr style="height: 50px" v-else>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="高分辨率" name="second">
                <div style="width: 100%;float: right;text-align: right;margin-right: 20px;">
                    <el-button size="mini" plain type="primary" v-display:sysExamRoom-img @click="downloadResult('page')" >导出图片座位帖</el-button>
                    <el-button size="mini" plain type="primary" v-display:sysExamRoom-pdf @click="printOutpdf('page')">导出PDF座位帖</el-button>
                    <el-button type="text" v-print="`#page`">在线打印</el-button>
                </div>
                <div style="width: 100%;height: 100%;margin-top: 30px;" id="page" >
                    <div v-for="(item,index) in examRoomStudentList" style="height: 2435px;">
                        <div v-for="ticketForm in item" style="height: 420px;width: 46%;float: left;margin-right: 20px;margin-top: 40px;margin-left: 40px;">
                            <table border="1" style="color:#000;font-size: 21px;text-align: center;height:420px;width: 100%;" cellspacing="0" cellpadding="0"  align="center">
                                <tr style="height: 50px">
                                    <th style="width: 160px">考生姓名</th>
                                    <td style="width: 120px">{{ticketForm.name}}</td>
                                    <th>性别</th>
                                    <td style="width: 80px">{{ticketForm.sex}}</td>
                                    <th>身份证号</th>
                                    <td>{{ticketForm.idCard}}</td>
                                </tr>
                                <tr style="height: 50px">
                                    <th>报考专业</th>
                                    <td colspan="3">{{ticketForm.examMajor}}</td>
                                    <th>准考证号</th>
                                    <td>{{ticketForm.ticketNumber}}</td>
                                </tr>
                                <tr style="height: 50px">
                                    <th>考试科目</th>
                                    <th>考试时间</th>
                                    <th>教室号</th>
                                    <th>考场号</th>
                                    <th>座位号</th>
                                    <th rowspan="3"><img style="width: 90%; height: 90%;margin-top: 10px;margin-left: 5%;margin-top: 5%" id="faceImg" :src="ticketForm.faceImg"/></th>
                                </tr>

                                <tr style="height: 50px" v-if="ticketForm.majorItemList && ticketForm.majorItemList[0]">
                                    <td>{{ticketForm.majorItemList[0].name}}</td>
                                    <td>{{ticketForm.majorItemList[0].examStartTime.substring(0,5)}}--{{ticketForm.majorItemList[0].examEndTime.substring(0,5)}}</td>
                                    <td>{{ticketForm.majorItemList[0].classroomNum}}</td>
                                    <td>{{ticketForm.majorItemList[0].examRoomNum}}</td>
                                    <td>{{ticketForm.majorItemList[0].seatNumber}}</td>
                                </tr>

                                <tr style="height: 50px" v-if="ticketForm.majorItemList && ticketForm.majorItemList[1]">
                                    <td>{{ticketForm.majorItemList[1].name}}</td>
                                    <td>{{ticketForm.majorItemList[1].examStartTime.substring(0,5)}}--{{ticketForm.majorItemList[1].examEndTime.substring(0,5)}}</td>
                                    <td>{{ticketForm.majorItemList[1].classroomNum}}</td>
                                    <td>{{ticketForm.majorItemList[1].examRoomNum}}</td>
                                    <td>{{ticketForm.majorItemList[1].seatNumber}}</td>
                                </tr>
                                <tr style="height: 50px" v-else>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    import axios from 'axios'
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf'
    let loading;
    export default {
        name: "saveOrUpdateSysExamRoomLook",
        props:["examRoomNum","classroomNum"],
        data(){
            return {
                searchForm:{
                    examRoomNum: '',
                    classroomNum: '',
                    pager:{
                        sortField:'examRoomNum',
                        sortOrder:'asc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'examRoomNum,classroomNum'
                    }
                },
                examRoomList:[],
                examRoomStudentList:[],
                roomName:'',
                config:config,
                activeName:'first'
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getExamRoomStudent(this.examRoomNum,this.classroomNum);
        },
        mounted(){
        },
        methods:{
            censusRoom(){
                axios({
                    url:`${home}/sysExamRoom/censusRoom`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    this.examRoomList = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getExamRoomStudent(roomCode,classroomNum){
                axios({
                    url:`${home}/sysExamRoom/findTicketsByStudents`,
                    method:'POST',
                    data:{
                        "examRoomNum":roomCode,
                        "classroomNum":classroomNum
                    }
                }).then(res=>{
                    for(let key in res.data){
                        let arr2 = res.data[key].map((value,key,arr) => {
                            this.getUrlBase64(config.resPre+value.faceImg, "jpg", function (base64) {
                                value.faceImg = base64;
                            });

                            return value;
                        });
                        res.data[key] = arr2;
                    }
                    this.examRoomStudentList = res.data;
                    this.roomName = classroomNum;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getBase64Img(){
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height);
                var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
                var dataURL = canvas.toDataURL("image/" + ext);
                return dataURL;
            },
            base64ImgtoFile(dataurl, filename = 'file') {
                let arr = dataurl.split(',')
                let mime = arr[0].match(/:(.*?);/)[1]
                let suffix = mime.split('/')[1]
                let bstr = atob(arr[1])
                let n = bstr.length
                let u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], `${filename}.${suffix}`, {
                    type: mime
                })
            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysExamRoom/${this.title==='增加'?'saveSysExamRoom':'update/updateSysExamRoom'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.title+'成功',
                                type: 'success'
                            });
                            this.$emit('closeSaveOrUpdate',true);
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            close(){
                this.$emit('closeSaveOrUpdateSysExamRoomLook');
            },
            dataURLToBlob(dataurl) {//ie 图片转格式
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime})
            },
            downloadResult(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let canvasID = document.getElementById(name);
                let a = document.createElement('a');
                html2canvas(canvasID).then(canvas => {
                    let dom = document.body.appendChild(canvas);
                    dom.style.display = "none";
                    a.style.display = "none";
                    document.body.removeChild(dom);
                    let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                    a.setAttribute("href", URL.createObjectURL(blob));
                    a.setAttribute("download", "的准考证.png")
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(blob);
                    document.body.removeChild(a);
                });
                loading.close();
            },
            /**
             *
             * @param url 图片路径
             * @param ext 图片格式
             * @param callback 结果回调
             */
            getUrlBase64(url, ext, callback) {
                var canvas = document.createElement("canvas");   //创建canvas DOM元素
                var ctx = canvas.getContext("2d");
                var img = new Image;
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = function () {
                    canvas.height = 140; //指定画板的高度,自定义
                    canvas.width = 150; //指定画板的宽度，自定义
                    ctx.drawImage(img, 0, 0, 140, 150); //参数可自定义
                    var dataURL = canvas.toDataURL("image/" + ext);
                    callback.call(this, dataURL); //回掉函数获取Base64编码
                    canvas = null;
                };

            },
            printOut(name) {
                // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
                $(window).scrollTop(0); // jQuery 的方法
                document.body.scrollTop = 0; // IE的
                document.documentElement.scrollTop = 0; // 其他
                this.downloadResult(name)
            },
            printOutpdf(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let shareContent = document.getElementById(name),//需要截图的包裹的（原生的）DOM 对象
                    width = shareContent.clientWidth, //获取dom 宽度
                    height = shareContent.clientHeight, //获取dom 高度
                    canvas = document.createElement("canvas"), //创建一个canvas节点
                    scale = 2; //定义任意放大倍数 支持小数
                canvas.width = width * scale; //定义canvas 宽度 * 缩放
                canvas.height = height * scale; //定义canvas高度 *缩放
                canvas.style.width = shareContent.clientWidth * scale + "px";
                canvas.style.height = shareContent.clientHeight * scale + "px";
                canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
                console.log(height+'======'+width);
                let opts = {
                    scale: scale, // 添加的scale 参数
                    canvas: canvas, //自定义 canvas
                    logging: false, //日志开关，便于查看html2canvas的内部执行流程
                    width: width, //dom 原始宽度
                    height: height,
                    useCORS: true, // 【重要】开启跨域配置
                };
                html2canvas(shareContent).then(canvas => {
                    var contentWidth = canvas.width;
                    var contentHeight = canvas.height;
                    //一页pdf显示html页面生成的canvas高度;
                    var pageHeight = (contentWidth / 592.28) * 841.89;
                    console.log(pageHeight);
                    //未生成pdf的html页面高度
                    var leftHeight = contentHeight;
                    //页面偏移
                    var position = 0;
                    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                    var imgWidth = 595.28;
                    var imgHeight = (592.28 / contentWidth) * contentHeight;
                    console.log(imgHeight);
                    var pageData = canvas.toDataURL("image/jpeg", 1.0);
                    var PDF = new JsPDF("", "pt", "a4");
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save("座位帖.pdf"); // 这里是导出的文件名
                    loading.close();
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
    .page
    {
        width: 26cm;
        height: 1530px;
        padding: 1cm;
        margin: 1cm auto;
        border-radius: 5px;
        background: white;
    }
    .pageStyle{
       float: left;height:275px;width: 46%;margin-top: 45px;margin-left: 30px;
    }
    .schoolProcessList {
        margin-top: 20px;
        list-style: none;
        // height: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        margin-left: -4%;
        // margin-top: -5%;
        // align-content: space-around;
        li {
            border-radius: 6px;
            background: #90EE90;
            margin-left: 4%;
            // margin-top: 5%;
            width: 12.6%;
            text-align: center;
            margin-bottom: 4%;
            img {
                margin: 12% auto 10%;
                width: 55%;
            }
            .oa-btn .el-button {
                min-width: 60%;
                max-width: 90%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-left: 5%;
                padding-right: 5%;
                margin-bottom: 18%;
                border-radius: 50px;
                padding-top: 4.5%;
                padding-bottom: 4.5%;

            }
        }
    }

</style>